import React from 'react';

import SearchIcon from '@mui/icons-material/Search';
import { Box, LinearProgress, InputBase } from '@mui/material';

interface SmsSearchInputProps {
  value: string;
  onChange: (value: string) => void;
  loading?: boolean;
}

const SmsSearchInput: React.FC<SmsSearchInputProps> = ({
  value,
  onChange,
  loading,
}) => {
  return (
    <Box sx={{ mb: 2 }}>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          bgcolor: '#F5F5F5',
          borderRadius: 1,
          px: 1.5,
          py: 1,
        }}
      >
        <SearchIcon sx={{ color: 'text.secondary', mr: 1 }} />
        <InputBase
          placeholder="Search"
          value={value}
          onChange={(e) => onChange(e.target.value)}
          sx={{ flex: 1, fontSize: 14 }}
          inputProps={{ 'aria-label': 'search conversations' }}
        />
      </Box>
      {loading ? (
        <LinearProgress
          color="info"
          sx={{ height: 2, borderRadius: 1, mt: 0.5 }}
        />
      ) : (
        <Box sx={{ height: 2, mt: 0.5 }} />
      )}
    </Box>
  );
};

export default SmsSearchInput;
